export default __webpack_public_path__ + "static/media/IconDesc_LiquidBiofuel_Pipe.256.6d459f75.png";